import { getRegionSlugBySlug, getRegionSlugByCooperative } from './get-region';

/**
 * Return a url replacing the slug of the current page region with the user's one
 * @param {object|string} userRegion - current user region
 * @param {object|string} pageRegion - current page region
 * @param {string} url - url to normalize
 * @returns {string} eventually a link to a new page
 * @example
 *
 * linkToSiblingRegion('zuerich', 'bern', 'produkte-bern/lebensmittel/baeckerei-confiserie-backen/brote')
 * // returns => produkte-zuerich/lebensmittel/baeckerei-confiserie-backen/brote
 */
export default function linkToSiblingRegion(userRegion, pageRegion, url) {
    const userRegionSlug = getRegionSlugBySlug(userRegion);
    const pageRegionSlug = getRegionSlugByCooperative(pageRegion);

    if (userRegionSlug !== pageRegionSlug) {
        return url.replace(pageRegionSlug, userRegionSlug);
    }

    return url;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/link-to-sibling-region.js